
<vac ref="countdown" :end-time="endTime" class="valeur_timer" @finish="restartVac">
  <span slot="process" slot-scope="{ timeObj }">
    {{ `${timeObj.h}:${timeObj.m}:${timeObj.s}` }}
  </span>
  <span slot="finish">00:00:00</span>
</vac>
